"use client";
import "./App.css";
import { useEffect } from "react";
import { Navigate, Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { createAuthorizeURL, initializeRsi, isExpiredAccessToken } from "./auth/RsiAuthService";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorContent } from "./common/components/ErrorContent";
import { getAuthItems } from "./auth/AuthItems";
import { Header } from "./home/Header";
import { LoginPage } from "./auth/LoginPage";
import { SerialPage } from "./home/SerialPage";
import { HelpPage } from "./HelpPage";
import { AdminLoginPage } from "./admin/AdminLoginPage";
import { AdminMenuPage } from "./admin/AdminMenuPage";
import { AdminListPage } from "./admin/AdminListPage";
import { TenantListPage } from "./admin/TenantListPage";

const BasePage = (): JSX.Element => {
  const isExpired = isExpiredAccessToken();

  useEffect(() => {
    (async () => {
      if (isExpired) {
        const authItems = getAuthItems();
        authItems.removeAll();
        // 未ログイン
        const url = await createAuthorizeURL();
        window.location.href = url;
        return;
      }

      initializeRsi();
    })();
  }, []);

  if (isExpired) {
    return <></>;
  }

  return (
    <div className="rcui-app-container">
      <Outlet />
    </div>
  );
};

const AdminBasePage = (): JSX.Element => {
  const isExpired = isExpiredAccessToken();

  useEffect(() => {
    (async () => {
      if (isExpired) {
        const authItems = getAuthItems();
        authItems.removeAll();
        // 未ログイン
        window.location.href = "/admin/login";
        return;
      }
    })();
  }, []);

  if (isExpired) {
    return <></>;
  }

  return (
    <div className="rcui-app-container">
      <Outlet />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/app",
    element: (
      <ErrorBoundary FallbackComponent={ErrorContent}>
        <Header />
        <BasePage />
      </ErrorBoundary>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="/app/serial" replace />,
      },
      {
        path: "serial",
        element: <SerialPage />,
      },
      {
        path: "help",
        element: <HelpPage />,
      },
    ],
  },
  {
    path: "/app/login",
    element: (
      <ErrorBoundary FallbackComponent={ErrorContent}>
        <LoginPage />
      </ErrorBoundary>
    ),
  },
  {
    path: "/admin",
    element: (
      <ErrorBoundary FallbackComponent={ErrorContent}>
        <Header />
        <AdminBasePage />
      </ErrorBoundary>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="/admin/login" replace />,
      },
      {
        path: "menu",
        element: <AdminMenuPage />,
      },
      {
        path: "list",
        element: <AdminListPage />,
      },
      {
        path: "tenantList",
        element: <TenantListPage />,
      },
    ],
  },
  {
    path: "/admin/login",
    element: (
      <ErrorBoundary FallbackComponent={ErrorContent}>
        <AdminLoginPage />
      </ErrorBoundary>
    ),
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
